// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowExpanderRight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-expander-right': IconArrowExpanderRight;
    }
}

/**
 * The icon component for the 'arrowExpanderRight' icon
 */
export class IconArrowExpanderRight extends Icon {
    public constructor() {
        super(arrowExpanderRight16X16);
    }
}

registerIcon('icon-arrow-expander-right', IconArrowExpanderRight);
export const iconArrowExpanderRightTag = 'nimble-icon-arrow-expander-right';
